import { Box, IconButton, Tooltip } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next";

const QuestionActions = ({ expand, openDrawer, disable, active, toggleExpand, downloadEvidences}: { expand: boolean; openDrawer: () => void; active:boolean, toggleExpand: () => void, downloadEvidences: () => Promise<void>, disable: boolean }) => {
    const styles = useStyles()
    const { t } = useTranslation()
    const handleServiceCall = (e: React.MouseEvent) => {
        e.stopPropagation() 
        downloadEvidences()
    }
    return (
        <Box sx={styles.headerAction}>
            {
                !active && (<>
                    <Tooltip title={t('schedule.buttons.download')}>
                        <IconButton sx={styles.download(disable)} onClick={handleServiceCall} disabled={disable}>
                            {icons('download')}
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={t('schedule.buttons.view')}>
                        <IconButton disabled={active} /* sx={styles.download} */ onClick={(e) => {
                            e.stopPropagation()
                            openDrawer()
                        }}>{icons('visibility')}</IconButton>
                    </Tooltip>
                </>)
            } 

            <IconButton 
                sx={[styles.arrow, styles.rotate(expand)]}
                onClick={(e) => {
                    e.stopPropagation(); 
                    toggleExpand(); 
                }}
            >{icons('arrow-down')}</IconButton>
        </Box>
    )
}

export { QuestionActions }